import { useState } from "react";
import { CalendarClock, ExternalLink } from "lucide-react";

const withParams = (url) => {
  const u = new URL(url);
  u.searchParams.set("embed_domain", window.location.hostname);
  u.searchParams.set("embed_type", "Inline");
  u.searchParams.set("hide_gdpr_banner", "1");
  u.searchParams.set("background_color", "ffffff");
  u.searchParams.set("text_color", "22304a");
  u.searchParams.set("primary_color", "6f5b9e");
  return u.toString();
};

const Placeholder = ({ text }) => (
  <div className="flex flex-col items-center justify-center gap-4 px-6 py-20 text-center" data-testid="booking-coming-soon">
    <CalendarClock className="h-8 w-8 text-[#B9A9D8]" aria-hidden="true" />
    <p className="max-w-md font-display text-2xl leading-snug text-[#22304A]">{text}</p>
  </div>
);

export const CalendlyEmbed = ({ book, consultUrl, sessionUrl, couplesUrl }) => {
  const [tab, setTab] = useState("consult");
  const tabs = [
    { id: "consult", label: book.consult_tab, url: consultUrl },
    { id: "session", label: book.session_tab, url: sessionUrl },
    { id: "couples", label: book.couples_tab, url: couplesUrl },
  ];
  const active = tabs.find((t) => t.id === tab);
  return (
    <div className="card-soft overflow-hidden" data-testid="calendly-section">
      <div role="tablist" aria-label="Choose what to book" className="flex flex-col gap-2 border-b border-[#B9A9D8]/40 p-3 sm:flex-row">
        {tabs.map((t) => (
          <button
            key={t.id}
            role="tab"
            aria-selected={tab === t.id}
            onClick={() => setTab(t.id)}
            className={`flex-1 rounded-full px-5 py-3 text-[15px] font-medium transition-colors duration-300 ${tab === t.id ? "bg-[#6F5B9E] text-white" : "text-[#22304A] hover:bg-[#B9A9D8]/20"}`}
            data-testid={`calendly-tab-${t.id}`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {active.url ? (
        <iframe
          key={active.url}
          title={`Book: ${active.label}`}
          src={withParams(active.url)}
          allow="payment"
          className="block h-[960px] w-full border-0 sm:h-[720px]"
          data-testid={`calendly-iframe-${active.id}`}
        />
      ) : (
        <Placeholder text={book.coming_soon} />
      )}
      <div className="flex flex-col gap-3 border-t border-[#B9A9D8]/40 px-6 py-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-relaxed text-[#6B7280]" data-testid="booking-note">{book.booking_note}</p>
        {active.url && (
          <a href={active.url} target="_blank" rel="noopener noreferrer" className="text-link inline-flex shrink-0 items-center gap-1.5 text-sm" data-testid={`calendly-open-new-tab-${active.id}`}>
            Calendar not showing? Open it here <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        )}
      </div>
    </div>
  );
};
